import axios, { AxiosInstance, AxiosResponse } from 'axios'
import AuthToken from '@/auth/auth-token'

class Notification {
  protected readonly notification: AxiosInstance;

  constructor () {
    const notification = axios.create({
      baseURL: process.env.VUE_APP_NOTIFICATION_API,
      headers: {
        'Content-type': 'application/json'
      }
    })

    this.notification = notification
  }

  handleSuccess (response: AxiosResponse) {
    return response
  }

  handleError (error: any) {
    return Promise.reject(error)
  }

  public getAllHistory = async (limit?: number, offset?: number) => {
    await AuthToken.setAuth(this.notification)

    const params: any = {}
    if (limit !== undefined) params.limit = limit
    if (offset !== undefined) params.offset = offset

    return this.notification({
      url: '/mobile-notifications/user-history',
      method: 'GET',
      params: params
    })
      .then(this.handleSuccess)
      .catch(this.handleError)
  }

  public sendNotification = async (data: {
    title: string;
    body: string;
    to_all?: boolean;
    subscription_name?: string;
    upstream_party_id?: string;
    email_list?: string[];
  }) => {
    await AuthToken.setAuth(this.notification)

    return this.notification({
      url: '/mobile-notifications/send',
      method: 'POST',
      data: data
    })
      .then(this.handleSuccess)
      .catch(this.handleError)
  }
}

export default new Notification()
